import React from 'react'
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import GenderSelect from './genderSelect';
import {  Input } from "antd";
import EditIcon from "@mui/icons-material/Edit";

const personalDetails = () => {
  return (
    <Row>
        <Col>
          <div className="personal-details ">
            <div className="title"> Personal Details </div>
            <div className="personal-content">
            <Row>
              <Col md={6}>
              <div className="name-info contact-info">
                <div className="label-account">Name*</div>
                <div className="acc-inp-cont ">
                <EditIcon className="edit-icon" />
                      <Input type="text" placeholder="Enter Name" className="number" />
                  </div>
              </div>

                {/* <div className="name-info">
                  <div>Name*</div>
                  <div className="name">Digant Bhatt</div>
                </div> */}
              </Col>
              <Col md={6}>
                <div className="gender test ">
                  {/* <div className='gender-title' >Gender</div> */}
                  <div className="label-account">Gender*</div>
                  <div className="gender-select"><GenderSelect /></div>
                </div>
              </Col>
            </Row>
              

              
            
            </div>
          </div>
        </Col>
      </Row>
  )
}

export default personalDetails